import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock, ArrowLeftRight, FileText, GraduationCap, Trophy, Check } from "lucide-react";

// Employee Portal Visual - Dashboard preview with hover effect
export const EmployeePortalVisual = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative w-full h-full p-3"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Card className={`h-full transition-all duration-300 ${isHovered ? 'opacity-100 shadow-lg' : 'opacity-60 grayscale'}`}>
        <CardHeader className="p-3 pb-2">
          <div className="flex items-center gap-2.5">
            <div className={`w-7 h-7 rounded-full bg-primary/20 flex items-center justify-center border-2 transition-all duration-300 ${isHovered ? 'border-primary/40 scale-105' : 'border-primary/20'}`}>
              <span className="text-[10px] font-bold text-primary">JD</span>
            </div>
            <div>
              <CardTitle className="text-xs font-semibold">Welcome back, John</CardTitle>
              <p className="text-[9px] text-muted-foreground">Your dashboard overview</p>
            </div>
          </div>
        </CardHeader>
        <CardContent className="p-3 pt-0">
          {/* Feature Grid - 2x3 */}
          <div className="grid grid-cols-2 gap-1.5">
            {/* My Shifts */}
            <div className={`p-2 rounded-lg bg-muted/40 border transition-all duration-300 ${isHovered ? 'border-border/50' : 'border-border/30'}`}>
              <div className="flex items-center gap-1.5 mb-1">
                <Calendar className="w-3 h-3 text-primary" />
                <span className="text-[9px] font-medium text-foreground">My Shifts</span>
              </div>
              <div className="flex gap-1">
                <div className="h-3 w-6 rounded-sm bg-blue-500/60" />
                <div className="h-3 w-5 rounded-sm bg-primary/40" />
              </div>
            </div>

            {/* Hours This Week */}
            <div className={`p-2 rounded-lg bg-muted/40 border transition-all duration-300 ${isHovered ? 'border-border/50' : 'border-border/30'}`}>
              <div className="flex items-center gap-1.5 mb-0.5">
                <Clock className="w-3 h-3 text-primary" />
                <span className="text-[9px] font-medium text-foreground">Hours</span>
              </div>
              <span className="text-sm font-bold text-foreground tabular-nums">32h</span>
            </div>

            {/* Shift Swaps */}
            <div className={`p-2 rounded-lg bg-muted/40 border transition-all duration-300 ${isHovered ? 'border-border/50' : 'border-border/30'}`}>
              <div className="flex items-center gap-1.5">
                <ArrowLeftRight className="w-3 h-3 text-primary" />
                <span className="text-[9px] font-medium text-foreground">Swaps</span>
                <div className={`w-3.5 h-3.5 rounded-full bg-primary text-[7px] text-white flex items-center justify-center ml-auto font-bold transition-transform duration-300 ${isHovered ? 'scale-110' : ''}`}>2</div>
              </div>
            </div>

            {/* Payslips */}
            <div className={`p-2 rounded-lg bg-muted/40 border transition-all duration-300 ${isHovered ? 'border-border/50' : 'border-border/30'}`}>
              <div className="flex items-center gap-1.5">
                <FileText className="w-3 h-3 text-primary" />
                <span className="text-[9px] font-medium text-foreground">Payslips</span>
                <div className="w-3.5 h-3.5 rounded-full bg-green-500/20 flex items-center justify-center ml-auto">
                  <Check className="w-2 h-2 text-green-500" />
                </div>
              </div>
            </div>

            {/* Training */}
            <div className={`p-2 rounded-lg bg-muted/40 border transition-all duration-300 ${isHovered ? 'border-border/50' : 'border-border/30'}`}>
              <div className="flex items-center gap-1.5 mb-1">
                <GraduationCap className="w-3 h-3 text-primary" />
                <span className="text-[9px] font-medium text-foreground">Training</span>
              </div>
              <div className="h-1 w-full rounded-full bg-muted overflow-hidden">
                <div className={`h-full rounded-full bg-primary transition-all duration-500 ${isHovered ? 'w-3/4' : 'w-1/2'}`} />
              </div>
            </div>

            {/* Achievements */}
            <div className={`p-2 rounded-lg bg-muted/40 border transition-all duration-300 ${isHovered ? 'border-border/50' : 'border-border/30'}`}>
              <div className="flex items-center gap-1.5">
                <Trophy className={`w-3 h-3 text-amber-500 transition-transform duration-300 ${isHovered ? 'scale-110' : ''}`} />
                <span className="text-[9px] font-medium text-foreground">Achievements</span>
                <span className="text-[10px] font-bold text-amber-500 ml-auto">5</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
